import { Field, Form } from 'formik';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ParadigmButton from '#/material/button';
import { FormattedParadigmInput } from '#/material/input';
import { ModalActionsWrapper } from '#/material/modal';

const useStyles = makeStyles((theme) => ({
  msg: {
    fontSize: '12px',
    lineHeight: '15px',
  },
  error: {
    border: '1px solid #F3E500',
    borderRadius: '7px',
    display: 'flex',
  },
  img: {
    height: '13px',
    width: '13px',
    margin: '14px 8px 0 12px',
  },
  field: {
    '& .MuiInputLabel-root': {
      color: '#7fabec',
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  sectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginTop: '16px',
    marginBottom: '8px',
    color: 'rgba(255, 255, 255, 0.87)',
  },
  disabled: {
    opacity: '0.3',
  },
}));

const EditMmpSettingsForm = (props) => {
  const classes = useStyles(props);
  const { isSubmitting, onClose, dirty, isValid } = props;

  return (
    <Form noValidate>
      <Field
        className={classes.field}
        name="execution_window"
        component={FormattedParadigmInput}
        label="Execution count time window"
        endAdornment="Seconds"
      />
      <Field
        className={classes.field}
        name="execution_limit"
        component={FormattedParadigmInput}
        label="Maximum # of executions allowed in window"
      />

      <Field
        className={classes.field}
        name="volume_threshold"
        component={FormattedParadigmInput}
        label="Notional volume limit"
      />
      <Field
        className={classes.field}
        name="volume_window"
        component={FormattedParadigmInput}
        label="Notional volume time window"
        endAdornment="Seconds"
      />
      <Field
        className={classes.field}
        name="mmp_reset_interval_seconds"
        component={FormattedParadigmInput}
        label="MMP Reset Time (MMP automatically disables)"
        endAdornment="Seconds"
        autoFocus
      />

      <ModalActionsWrapper>
        <ParadigmButton secondary text="Cancel" onClick={onClose} />
        <ParadigmButton
          type="submit"
          className={!isValid || !dirty ? classes.disabled : null}
          busy={isSubmitting}
          disabled={!dirty}
          text="Save"
        />
      </ModalActionsWrapper>
    </Form>
  );
};

export default EditMmpSettingsForm;
